module.exports = __webpack_public_path__ + "img/audi.aa5e6acf.webp";